import React, { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import useRoutes from './routes'
import AppFooter from './components/AppFooter/AppFooter'
import AppHeader from './components/AppHeader/AppHeader'
import stylesComponents from './components/styles/index'
import RootStore from './store/RootStore'
import { observer } from 'mobx-react-lite'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { amber, grey } from '@mui/material/colors'
import { PaletteMode } from '@mui/material'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './Variables.scss'
import { socket } from './service/Socket'

export const App = observer(() => {
  const { isAdmin, isAuth } = RootStore.authStore
  const routes = useRoutes({ isAuthentificated: isAuth, isAdmin: isAdmin })

  React.useEffect(() => {
    stylesComponents()
    RootStore.authStore.init()
    const mySocket = socket
  }, [])

  const darkModeTheme = createTheme(getDesignTokens('dark'))

  return (
    <ThemeProvider theme={darkModeTheme}>
      <div className="App">
        <BrowserRouter>
          <AppHeader />
          <div className="App-container">
            <Suspense fallback={<div>Загрузка... </div>}>{routes}</Suspense>
          </div>
          <AppFooter />
        </BrowserRouter>

        <ToastContainer
          position="bottom-left"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          pauseOnHover={false}
          draggable
        />
      </div>
    </ThemeProvider>
  )
})

const getDesignTokens = (mode: PaletteMode) => ({
  palette: {
    mode,
    primary: {
      ...amber,
      ...(mode === 'dark' && {
        main: amber[300],
      }),
    },
    text: {
      ...(mode === 'light'
        ? {
            primary: grey[900],
            secondary: grey[800],
          }
        : {
            primary: '#fff',
            secondary: grey[500],
          }),
    },
  },
})
